module.exports = __webpack_public_path__ + "static/img/佳尼特 蓝鲸TJ3.dda90a83.png";